module.exports = __webpack_public_path__ + "static/media/picto-sharing-black.e521ebb6.svg";